import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router, ActivationEnd, RouterEvent } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';

import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatToolbarModule } from '@angular/material/toolbar';

import { DeviceDetectorService } from 'ngx-device-detector';

import { MobileDisplayDialogComponent } from '../mobile-display-dialog/mobile-display-dialog.component';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';

import { SessionService } from '../../services/session.service';
import { NavigationService } from '../../services/navigation.service';
import { UserService } from '../../services/user.service';
import { CompanyService } from '../../services/company.service';

import { NavigationOptions } from '../../models/navigation';
import { CompanyInformation } from '../../models/company';
import { reduce } from 'rxjs/operators';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  private _handleError: HandleError;
  private _logging = environment.logging;
  private _assetSettings = environment.assets;
  private _display = environment.display;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  appInfo = environment.appInfo;
  appUrls = environment.appUrls;

  navigationOptions: NavigationOptions;
  isNavigationTwoRows = false;
  routePath = 'login';        // 10/28/2021 RA - Initialize routePath with initial value of Login screen.

  companyInformation: CompanyInformation;

  showFiller = false;
  @ViewChild('drawer', { static: true }) drawer!: MatDrawer;

  constructor(
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _sessionService: SessionService,
    private _navigationService: NavigationService,
    private _userService: UserService,
    private _companyService: CompanyService,
    private _deviceService: DeviceDetectorService,
    public mobileDisplayDialog: MatDialog,
    public media: MediaObserver,
    private breakpointObserver: BreakpointObserver
  ) {
    this._handleError = _errorHandler.createHandleError('PageHeaderComponent');

    this.navigationOptions = _navigationService.getNewNavigationOptions();
    this.routePath = 'login';  // 10/27/2021 RA - Initialize routePath with initial value of Login screen.

    // Cannot use ActivatedRoute.data.subscribe() because the page header is outside the <router-outlet>
    // Must use Router.events.subscribe() instead
    this._router.events.subscribe((e: RouterEvent) => {
      if (e instanceof ActivationEnd) {
        if (e.snapshot.routeConfig !== undefined && e.snapshot.routeConfig !== null && e.snapshot.routeConfig.path !== undefined) {
          this.routePath = e.snapshot.routeConfig.path.toLowerCase();
          this.navigationOptions = this._navigationService.getNavigationOptionsForPath(e.snapshot.routeConfig.path.toLowerCase());
          this.isNavigationTwoRows = this._navigationService.isNavigationTwoRows(e.snapshot.routeConfig.path.toLowerCase());
          // 10/30/2021 RA - Modified to include all screens that need different formatting when in Mobile mode.
          if (this.routePath.toLowerCase() !== 'home' && this.routePath.toLowerCase() !== 'login' && this.routePath.toLowerCase() !== 'profile' &&
              this.routePath.toLowerCase() !== 'contactus' && this.routePath.toLowerCase() !== 'quickpay' && this.routePath.toLowerCase() !== 'faq' &&
              this.routePath.toLowerCase() !== 'forgotusername' && this.routePath.toLowerCase() !== 'forgotpassword' && this.routePath.toLowerCase() !== '**' &&
              this.routePath.toLowerCase() !== 'register' && this.routePath.toLowerCase() !== 'verify' && this.routePath.toLowerCase() !== 'loginonetime' &&
              this.routePath.toLowerCase() !== 'paynow' && this.routePath.toLowerCase() !== 'quickpay_pay') {
                this.onResize(null);
              }
        } else {
          this.routePath = 'login';    // 10/28/2021 RA - Route page to the Login screen.
          this.navigationOptions = this._navigationService.getNewNavigationOptions();
          this.isNavigationTwoRows = this._navigationService.isNavigationTwoRows();
        }
      }
    });

    this.companyInformation = this._companyService.getNewCompanyInformation();

    this._companyService.companyInformation.subscribe(
      response => (this.companyInformation = response),
      error => this._handleError('companyInformation.subscribe', error)
    );
  }

  ngOnInit() {

    this.breakpointObserver
        .observe(['(orientation: portrait)', '(orientation: landscape)'])
        .subscribe(result => {
            console.log("ORIENTATION CHANGE");
            console.log(this.drawer);
        // If the drawer is open and the orientation changes, close it.
            if (this.drawer.opened) {
                console.log("DRAWER IS OPEN");
                this.drawer.close();
            }
    });

    // // Example 2 (optional): Listen for a specific breakpoint, e.g. small screens.
    // this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe(result => {
    //     if (this.drawer.opened && result.matches) {
    //     this.drawer.close();
    //     }
    // });
    this.onResize(null);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // May need to use screen height as the width if the device browser does not flip the screen width & height on orientation changes
    const useScreenHeightAsWidth: boolean = window.innerWidth > window.innerHeight && screen.width < screen.height;
    const screenWidth: number = useScreenHeightAsWidth ? screen.height : this._deviceService.isDesktop() ? window.innerWidth : screen.width;
    // 10/30/2021 RA - Modified to include all screens that need different formatting when in Mobile mode.
    if (this.routePath.toLowerCase() !== 'home' && this.routePath.toLowerCase() !== 'login' && this.routePath.toLowerCase() !== 'profile' &&
        this.routePath.toLowerCase() !== 'contactus' && this.routePath.toLowerCase() !== 'quickpay' && this.routePath.toLowerCase() !== 'faq' &&
        this.routePath.toLowerCase() !== 'forgotusername' && this.routePath.toLowerCase() !== 'forgotpassword' && this.routePath.toLowerCase() !== '**' &&
        this.routePath.toLowerCase() !== 'register' && this.routePath.toLowerCase() !== 'verify' && this.routePath.toLowerCase() !== 'loginonetime' &&
        this.routePath.toLowerCase() !== 'paynow' && this.routePath.toLowerCase() !== 'quickpay_pay') {
    //   if (screenWidth < this._display.mobileDisplayDialogTriggerWidth) {
    //     const dialogRef = this.mobileDisplayDialog.open(MobileDisplayDialogComponent, {
    //      width: '95%',
    //      disableClose: true,
    //      data: {}
    //    });

    //    dialogRef.afterClosed().subscribe(returnData => {
    //      if (this._logging.navigationTraceLog) {
    //        console.log('PageHeaderComponent.viewDisclosures :: Dialog Closed');
    //      }
    //    });
    //   }
    }
  }

  showLoanDetails = false;
  showPayments = false;

  toggleLoanDetails(): void {
    this.showLoanDetails = !this.showLoanDetails;
  }

  togglePayments(): void {
    this.showPayments = !this.showPayments;
  }

  activeItem: string | null = null;

  setActiveItem(item: string): void {
    this.activeItem = item;
  }

  isLoggedIn(): boolean {

    if (this.routePath.toLowerCase() === 'verify')
        return false;
    
    return this._userService.isLoggedIn(false);
  }

  getLogoUrl(): string {
    return this.companyInformation.companyLogoFileName !== null
      ? this._assetSettings.urlPrefix + this.companyInformation.companyLogoFileName
      : 'login';   // 10/25/2021
  }

  openHome() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openHome');
    }
    this._router.navigate(['']);    // 10/25/2021 RA
  }

  openQuickPayLogin() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openQuickPayLogin');
    }
    this._router.navigate(['quickpay']);
  }

  openContactUs() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openContactUs');
    }
    this._router.navigate(['contactus']);
  }

  login() {
    this._userService.logout();

    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.login');
    }
    this._router.navigate(['login']);
  }

  logout() {
    this._userService.logout();

    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.logout');
    }
    this._router.navigate(['login']);
  }

  openProfile() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openProfile');
    }
    this._router.navigate(['profile']);
  }

  openLoanDetails() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openLoanDetails');
    }
    this._router.navigate(['loandetails']);
  }

  openESign() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openESign');
    }
    this._router.navigate(['esigndetails']);
  }

  openPayNow() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openPayNow');
    }
    this._router.navigate(['paynow']);
  }

  openTransactionHistory() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openTransactionHistory');
    }
    this._router.navigate(['transactionhistory']);
  }

  openSetupCancelAutoPay() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openSetupCancelAutoPay');
    }
    this._router.navigate(['autopay']);
  }

  openMilitaryBenefits() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openMilitaryBenefits');
    }
    window.open(this.companyInformation.militaryBenefitsURL, '_blank');
  }

  openFAQ() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openFAQ');
    }
    this._router.navigate(['faq']);
  }

  openResources() {
    if (this._logging.navigationTraceLog) {
      console.log('PageHeaderComponent.openResources');
    }
    window.open(this.companyInformation.resourceURL, '_blank');
  }

  isSelectedButton(buttonId: string = ''): boolean {
    let isSelectedButton = false;
    switch (buttonId.toUpperCase().trim()) {
      case 'ACCOUNTINFO': {
        isSelectedButton = this.routePath.toLowerCase().includes('accountinfo');
        break;
      }
      case 'LOANDETAILS': {
        isSelectedButton = this.routePath.toLowerCase().includes('loandetails') || this.routePath.toLowerCase().includes('esigndetails');
        break;
      }
      case 'PAYMENTS': {
        isSelectedButton =
          this.routePath.toLowerCase().includes('paynow') ||
          this.routePath.toLowerCase().includes('paymenthistory') ||
          this.routePath.toLowerCase().includes('autopay');
        break;
      }
      case 'CONTACTUS': {
        isSelectedButton = this.routePath.toLowerCase().includes('contactus');
        break;
      }
      case 'FAQ': {
        isSelectedButton = this.routePath.toLowerCase().includes('faq');
        break;
      }
      case 'QUICKPAY': {
        isSelectedButton = this.routePath.toLowerCase().includes('quickpay');
        break;
      }
      default: {
        isSelectedButton = false;
        break;
      }
    }
    return isSelectedButton;
  }
}
